import React from 'react';
import { type GridColDef } from '@mui/x-data-grid-premium';

import { useSettings } from 'app/main/components';
import { ViewTable, ViewTableUtils } from 'app/main/components/page-layouts';
import { LineTotalCell, LinesTableFooterInfo } from 'app/main/modules/components/LinesTableUtils';

interface ErpQuotationsLinesTabProps {
	quotationErpId: string;
	refresh: boolean;
	updateRefresh: () => void;
}

export default function ErpQuotationsLinesTab(props: ErpQuotationsLinesTabProps) {
	const { t } = useSettings();

	const columns: GridColDef[] = [
		{
			field: 'quli_item_erp_id',
			headerName: t('DETAILS_ERP_QUOTATIONS_LINES_FIELD_ERP_ID'),
			minWidth: 100,
			renderCell: ViewTableUtils.renderCellWithTooltip
		},
		{
			field: 'quli_description',
			headerName: t('DETAILS_ERP_QUOTATIONS_LINES_FIELD_DESCRIPTION'),
			minWidth: 400,
			flex: 4,
			renderCell: ({ value, row }) =>
				ViewTableUtils.renderCellWithTooltip({
					value: row.quli_item_erp_id ? value : <i>{value}</i>,
					to: { module: 'items', uid: row.quli_item_uid }
				}),
			hideable: false
		},
		{
			field: 'quli_quantity',
			type: 'number',
			headerName: t('DETAILS_ERP_QUOTATIONS_LINES_FIELD_QUANTITY'),
			minWidth: 100,
			renderCell: ViewTableUtils.renderCellWithTooltip
		},
		{
			field: 'quli_base_price',
			type: 'number',
			headerName: t('DETAILS_ERP_QUOTATIONS_LINES_FIELD_BASE_PRICE'),
			minWidth: 100,
			renderCell: ViewTableUtils.renderCurrency,
			hideable: false
		},
		{
			field: 'quli_discount',
			type: 'number',
			headerName: t('DETAILS_ERP_QUOTATIONS_LINES_FIELD_DISCOUNT'),
			minWidth: 100,
			renderCell: ViewTableUtils.renderPercentage
		},
		{
			field: 'quli_unit_price',
			type: 'number',
			headerName: t('DETAILS_ERP_QUOTATIONS_LINES_FIELD_UNIT_PRICE'),
			minWidth: 125,
			renderCell: ViewTableUtils.renderCurrency,
			hideable: false
		},
		{
			field: 'quli_tot_value_tax_excl',
			type: 'number',
			headerName: t('DETAILS_ERP_QUOTATIONS_LINES_FIELD_TOT_TAX_EXCL'),
			minWidth: 125,
			renderCell: ({ value, row }) => <LineTotalCell price={value} isGift={row.quli_gift} />,
			hideable: false
		},
		{
			field: 'quli_tot_value_tax_incl',
			type: 'number',
			headerName: t('DETAILS_ERP_QUOTATIONS_LINES_FIELD_TOT_TAX_INCL'),
			minWidth: 125,
			renderCell: ({ value, row }) => <LineTotalCell price={value} isGift={row.quli_gift} />,
			hideable: false
		}
	];

	return (
		<ViewTable
			module="erp_quotations_lines"
			columns={columns}
			defaultFilters={[
				{
					filt_field: 'quli_quot_erp_id',
					filt_clause: 'equals',
					filt_value: props.quotationErpId
				}
			]}
			refresh={props.refresh}
			updateRefresh={props.updateRefresh}
			showExportButton={false}
			slots={{
				footerCustomInfo: ({ additionalInfo }) => (
					<LinesTableFooterInfo
						totTaxExcl={additionalInfo.tot_value_tax_excl}
						totTaxIncl={additionalInfo.tot_value_tax_incl}
					/>
				)
			}}
		/>
	);
}
